import { create } from "apisauce";

const api = create({
  // baseURL: 'http://localhost:5000',
  baseURL: "https://api.guiabasicodeplantao.com",
  timeout: 30000,
});

export default api;
